
import React from 'react';

const HalalArrow = (props: { className: any, onClick?: any }) => {
    const { className, onClick } = props;

    const handleOnClick = (e: any) => {

        if (onClick) onClick(true);
    }

    return (

        <svg className={className} onClick={handleOnClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
            <g>
                <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />

            </g>
        </svg>

    );
};
export default HalalArrow;

